import React, { useEffect, useState } from "react";
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

const SmsTranscation = ({ month, year, vendor }) => {

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [tabHeading, setTabHeading] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await fetch(
                    `${process.env.REACT_APP_URL_SIDE}/Sucess/SmsTranscation`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({ month, year, vendor }),
                    }
                );

                const result = await res.json();

                if (Array.isArray(result.data)) {
                    setTabHeading(result.heading);
                    setData(result.data);
                } else {
                    setData([]);
                }

            } catch (err) {
                console.error("Error:", err);
                setData([]);
            } finally {
                setLoading(false);
            }
        };

        if (month && year) {
            setLoading(true); 
            fetchData();
        }

    }, [month, year, vendor]);

    const totals = data.reduce(
        (acc, item) => {
            acc.tot_availTrans += item.tot_avail_trans || 0;
            acc.tot_sucess_count += item.total_sucess_sms_count || 0;
            acc.totpercentSentSms += item.perc_transsent || 0;
            return acc;
        },
        {
            tot_availTrans: 0,
            tot_sucess_count: 0,
            totpercentSentSms: 0
        }
    );

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Box sx={{ display: 'flex' }}>
                    <CircularProgress />
                </Box>
            </div>
        );
    }

    if (data.length === 0) {
        return <div className="mainhead" align='center'>No data found</div>;
    }

    return (

        <>
        <table align="center" border={1} width="60%">

            <thead>
                <tr className="tableheader">
                    <th colSpan={7}>{tabHeading}</th>
                </tr>
                <tr className="tableheader">
                    <th>Sl.No</th> 
                    <th>District</th>
                    <th>Vender</th>
                    <th>Total <br></br>Transactions</th>
                    <th>SMS Sent <br></br>to beneficiaries</th>
                    <th>% of Sms <br></br>Sent</th>
                </tr>
            </thead>

            <tbody>
                {data.map((item, index) => (
                    <tr key={item.dist_code || index}>
                        <td align="center">{index + 1}</td>
                        <td>{item.dist_name_en}</td>
                        <td align="right">{item.vendor}</td>
                        <td align="right">{item.tot_avail_trans}</td>
                        <td align="right">{item.total_sucess_sms_count}</td>
                        <td align="right">
                            {Number(item.perc_transsent || 0).toFixed(3)}
                        </td>
                    </tr>
                ))}

                {/*  Total Row */}
                <tr className="tableheader">
                    <td colSpan={3} style={{ textAlign: 'center', fontWeight: 'bold' }}>Total:</td>

                    <td style={{ textAlign: 'right', fontWeight: 'bold' }}>
                        {totals.tot_availTrans}
                    </td>

                    <td style={{ textAlign: 'right', fontWeight: 'bold' }}>
                        {totals.tot_sucess_count}
                    </td> 

                       <td style={{ textAlign: 'right', fontWeight: 'bold' }}>
                        {totals.totpercentSentSms || 0 ? totals.totpercentSentSms.toFixed(3) : "0.000"}
                    </td>

                </tr>

            </tbody>
        </table>  
<br></br>
    
</>
    );
};

export default SmsTranscation;